<template>
  <div class="quiz-coin">
    <div class="tip"></div>
    <div class="content" @click="linkTo('Store')">
      <i></i>
      <span>{{ amount.quizRemainNum }}</span>
      <div class="more">
        <span>+</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['amount'])
  },
  methods: {
    linkTo(name) {
      this.$router.push({
        name: name
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.quiz-coin {
  position: absolute;
  top: 0;
  right: 0;
  .tip {
    position: absolute;
    top: get_vw(2px);
    left: get_vw(-180px);
    width: get_vw(173px);
    height: get_vw(36px);
    background-image: url('https://website.xdcdn.net/poster/58881/20250717/LYvnz0rW.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    // background-color: rgba(0, 0, 0, 0.5);
    // border-radius: get_vw(10px);
    // color: #fff;
    // font-size: get_vw(16px);
    // &::after {
    //   content: '';
    //   position: absolute;
    //   top: 50%;
    //   margin-top: get_vw(-11px);
    //   right: get_vw(-20px);
    //   width: 0;
    //   height: 0;
    //   border: get_vw(11px) solid transparent;
    //   border-left-color: rgba(0, 0, 0, 0.5);
    // }
  }
  .content {
    position: relative;
    box-sizing: border-box;
    width: get_vw(177px);
    height: get_vw(40px);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 get_vw(16px);
    background-color: rgba(0, 0, 0, 0.5);
    border: get_vw(2px) solid rgba(255, 255, 255, 0.2);
    border-radius: get_vw(10px);
    color: #fff;
    font-size: get_vw(20px);

    i {
      display: inline-block;
      @include sprite_bg('quiz_coin');
      width: get_vw(24px);
      height: get_vw(26px);
      margin-right: get_vw(10px);
    }

    .more {
      position: absolute;
      width: get_vw(28px);
      height: get_vw(28px);
      right: get_vw(6px);
      top: 50%;
      transform: translate3d(0, -50%, 0);
      border-radius: get_vw(4px);
      background-color: #F8CD0A;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        margin-top: get_vw(2px);
        color: #15322D;
        font-size: get_vw(30px);
        // font-weight: bold;
      }
    }
  }
}
</style>